import template from 'lodash-es/template';
import mapValues from 'lodash-es/mapValues';
import eachDeep from 'deepdash-es/eachDeep';
import includes from 'lodash-es/includes';
import isString from 'lodash-es/isString';

var settings = {
  escape: /\$\{-([\s\S]+?)\}/g,
  evaluate: /\$\{=([\s\S]+?)\}/g,
  interpolate: /\$\{([\s\S]+?)\}/g,
};

export default function(stylePatch, templateVars) {
  templateVars = mapValues(templateVars, (value, key) => {
    if (isString(value) && includes(value, '${')) {
      value = template(value, settings)(templateVars);
    }

    return value;
  });
  eachDeep(
    stylePatch,
    function(value, key, parent) {
      if (isString(value) && includes(value, '${')) {
        parent[key] = template(value, settings)(templateVars);
      }
    },
    { includeRoot: false }
  );
  return stylePatch;
}
